<template>
    <v-container>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="3" class="yellow lighten-4 font-weight-bold">File Berita Acara Klarifikasi Negosiasi</v-col>
                    <v-col v-if="baKlarifkasiNegosiasi != null && baKlarifkasiNegosiasi.fileBaKlarifikasiNegosiasi !== ''">
                        <v-btn icon @click="tenderLib.getFileDownloadLink(paket.id, `FileBaKlarifikasiNegosiasi_${baKlarifkasiNegosiasi.vendorId}`, baKlarifkasiNegosiasi.fileBaKlarifikasiNegosiasi, false)"><v-icon color="green">get_app</v-icon></v-btn>
                        {{ baKlarifkasiNegosiasi.fileBaKlarifikasiNegosiasi }}
                    </v-col>
                    <v-col v-else>
                        Admin belum mengirim berita acara klarifikasi negosiasi
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>


<script>

import { TenderLib } from "../../lib/tenderLib";
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API

export default {

    data() {
        return {
            tenderLib: TenderLib,
            baKlarifkasiNegosiasi: [],
        }
    },

    computed: {
        paket() {
            return this.$store.getters['lelang/paket'];
        },
    },

    watch: {
        paket() {

        }
    },
    mounted(){
        this.getData()
    },
    methods: {
        async getData() {
            const vendorId = this.$store.getters["ven/venId"];
            await axios.get(`${apiUrl}/api/lelang/ba-klarifikasi-negosiasi/vendor/${this.paket.id}/${vendorId}`)
            .then( (response) => {
                this.baKlarifkasiNegosiasi = response.data[0];
               

            }).catch( (error) => {
                console.error(error);
            });
        }
    }
}

</script>
